<template>
  <div>

    <h2 class="call-name">{{ title }} <small><code>/f13/{{ callName }}</code></small></h2>

    <div class="params">
      <div :class="{'form-group': true, row: true, 'has-danger': !params.perf_id}">
        <label for="perf-id" class="col-3 col-form-label">Performance ID</label>
        <div class="col-3">
          <input v-model="params.perf_id" type="text" class="form-control" id="perf-id">
        </div>
      </div>
      <button @click="updateQueryFromParams()" type="button" class="btn btn-primary">Go</button>
    </div>

    <api-result :results="results" :response="response" :loading="loading">
      <h3>Send Methods</h3>
      <ul>
        <li v-for="sendMethod in results">
          <p>{{ sendMethod.send_code }} == {{ sendMethod.send_desc }}</p>
          <p>Cost = {{ formatPrice(sendMethod.send_cost) }}</p>
        </li>
      </ul>
    </api-result>

  </div>
</template>


<script>
import apiCallMixin from './ApiCallMixin'
import ApiResult from './ApiResult'
export default {
  name: 'sendMethods',
  mixins: [apiCallMixin],
  components: { ApiResult },
  data () {
    return {
      title: 'Send Methods',
      callName: 'send_methods',
      params: {
        perf_id: ''
      }
    }
  },
  methods: {
    validateForm () {
      if (!this.params.perf_id) {
        return false
      }
      return true
    },
    parseResponse (response, success) {
      if (success) {
        this.results = []
        let sendMethods = response.body['send_methods']['send_method']
        this.results = sendMethods
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.results {
  li {
    margin-bottom: 2rem;
    p {
      margin-bottom: 0;
    }
    p + p {
      font-size: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SendMethods.vue?3fa83f04